// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = 'https://arzdpniijwnzlpkukabn.supabase.co';
const SUPABASE_PUBLISHABLE_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFyemRwbmlpanduemxwa3VrYWJuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzI1MzAwNzEsImV4cCI6MjA0ODEwNjA3MX0.wCu-e1xmEcpbXDe_ST7FHhPCYQAdCdMEXqP7KMeAiP0';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
    },
  }
);

// Register this immediately after calling createClient!
// Because signInWithOAuth causes a redirect, you need to fetch the
// provider tokens from the callback.
supabase.auth.onAuthStateChange((event, session) => {
  if (session && session.provider_token) {
    window.localStorage.setItem('oauth_provider_token', session.provider_token);
    if (session?.user?.email && session?.user?.id) {
      if (typeof (window as any).gr === 'function') {
        (window as any).gr("track", "conversion", { email: session?.user?.email, uid: session?.user?.id }); // Replace with actual email from signup form
      } else {
        console.log('gr function NOT defined.');
      }
    }
  }
  if (session && session.provider_refresh_token) {
    console.log(
      'OAuth provider refresh token:',
      session.provider_refresh_token
    );
    window.localStorage.setItem(
      'oauth_provider_refresh_token',
      session.provider_refresh_token
    );
  }
  if (event === 'SIGNED_OUT') {
    window.localStorage.removeItem('oauth_provider_token');
    window.localStorage.removeItem('oauth_provider_refresh_token');
  }
});
